if (!customElements.get('naked-reservation')) {
  customElements.define('naked-reservation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.productInfo = this.closest('product-info');
      this.form = this.querySelector('form');
      this.models = JSON.parse(this.querySelector('[data-reservation-models]').textContent);
      this.title = JSON.parse(this.querySelector('[data-reservation-title]').textContent);
      this.syncDevice(this.dataset.model);
      this.productInfo?.addEventListener('change', event => {
        if (!event.target.closest('variant-selects')) return;
        this.syncDevice(event.target.value);
      }, { signal });
      this.form.addEventListener('submit', event => {
        const picker = this.productInfo?.querySelector('variant-selects select, variant-selects input:checked');
        if (!this.syncDevice(picker?.value || this.dataset.model, true)) {
          event.preventDefault();
          picker?.focus();
        }
      }, { signal });
    }

    disconnectedCallback() { this.controller?.abort(); }

    syncDevice(model, preserveSignup = false) {
      if (!this.models.includes(model)) return false;
      this.dataset.model = model;
      const preference = `reservation-${this.dataset.design}-${model.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
      this.querySelector('[data-reservation-tags]').value = `newsletter,first-access,reservation,reservation-${this.dataset.design},${preference}`;
      this.querySelector('[data-reservation-selection]').textContent = `${this.title} / ${model}`;
      const picker = this.productInfo?.querySelector('variant-selects select');
      const selectedOption = Array.from(picker?.options || []).find(option => option.value === model);
      const optionId = selectedOption?.dataset.optionValueId;
      const variantId = new URL(window.location.href).searchParams.get('variant');
      const returnField = this.form.querySelector('input[name="return_to"]');
      const selectionQuery = '?customer_posted=true' + (optionId ? `&option_values=${encodeURIComponent(optionId)}` : variantId ? `&variant=${encodeURIComponent(variantId)}` : '');
      if (returnField) {
        // The capture-phase signup handler has already correlated this submit.
        // Preserve that ID while refreshing the device choice, not on ordinary changes.
        const target = new URL(`${this.dataset.productUrl}${selectionQuery}#${this.id}`, window.location.href);
        if (preserveSignup && returnField.value) {
          const previous = new URL(returnField.value, window.location.href);
          const signupId = previous.searchParams.get('nc_signup');
          if (previous.origin === target.origin && previous.pathname === target.pathname &&
              previous.hash === target.hash && /^nfs_[0-9a-f-]{36}$/i.test(signupId || '')) {
            target.searchParams.set('nc_signup', signupId);
          }
        }
        returnField.value = `${target.pathname}${target.search}${target.hash}`;
      }
      return true;
    }
  });
}
